(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpm-announcement"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('.tpm-announcement__slider[data-autoplay="true"]');
    sliders.forEach(function(slider) {
      const slides = slider.querySelectorAll('.tpm-announcement__slide');
      if (slides.length <= 1) return;
      let current = 0;
      const speed = parseInt(slider.dataset.speed) || 4000;
      setInterval(function() {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, speed);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
